// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import RoomService from "@material-ui/icons/RoomService";
// import ContentPaste from "@material-ui/icons/ContentPaste";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Settings from "@material-ui/icons/Settings";
import Unarchive from "@material-ui/icons/Unarchive";
// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import ProcessingPage from "views/Processing/Processing.jsx";
import TableList from "views/TableList/TableList.jsx";
import Orders from "views/Orders/Orders.jsx";
import Services from "views/Services/Services.jsx";
import Discounts from "views/Discounts/Discounts.jsx";

const dashboardRoutes = [
  {
    path: "/afgreidsla",
    sidebarName: "Afgreiðsla",
    navbarName: "Afgreiðsla",
    icon: RoomService,
    component: ProcessingPage,
    allowedRoles: ['staff', 'admin']
  },
  {
    path: "/dashboard",
    sidebarName: "Yfirlit",
    navbarName: "Yfirlit",
    icon: Dashboard,
    component: DashboardPage,
    allowedRoles: ['admin']
  },
  {
    path: "/orders",
    sidebarName: "Bókanir",
    navbarName: "Bókanir",
    icon: 'time_to_leave',
    component: Orders,
    allowedRoles: ['staff', 'admin']
  },
  {
    path: "/services",
    sidebarName: "Þjónustur",
    navbarName: "Þjónustur",
    icon: "local_car_wash",
    component: Services,
    allowedRoles: ['admin']
  },
  {
    path: "/discounts",
    sidebarName: "Afslættir",
    navbarName: "Afslættir",
    icon: LocalOffer,
    component: Discounts,
    allowedRoles: ['admin']
  },
  {
    path: "/staff",
    sidebarName: "Starfsmenn",
    navbarName: "Starfsmenn",
    icon: SupervisorAccount,
    component: TableList,
    allowedRoles: ['admin']
  },
  {
    path: "/settings",
    sidebarName: "Stillingar",
    navbarName: "Stillingar",
    icon: Settings,
    component: TableList,
    allowedRoles: ['admin']
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx